import type { ReactNode } from 'react';

interface ConfirmModalProps {
  open: boolean;
  title?: string;
  message: ReactNode;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({
  open,
  title = '确认操作',
  message,
  confirmText = '确认',
  cancelText = '取消',
  danger = false,
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onCancel}></div>
      <div className="relative bg-white rounded-2xl w-full max-w-sm mx-4 shadow-2xl animate-in fade-in zoom-in-95">
        <div className="p-6 text-center">
          <div className={`w-12 h-12 mx-auto mb-4 rounded-full flex items-center justify-center ${danger ? 'bg-red-50' : 'bg-amber-50'}`}>
            <i className={`text-xl ${danger ? 'ri-error-warning-line text-red-500' : 'ri-information-line text-amber-500'}`}></i>
          </div>
          <h3 className="font-bold text-foreground-950 text-base mb-2">{title}</h3>
          <div className="text-gray-500 text-sm leading-relaxed">{message}</div>
        </div>
        <div className="flex border-t border-gray-100">
          <button
            onClick={onCancel}
            className="flex-1 py-3.5 text-sm font-medium text-gray-500 hover:bg-gray-50 rounded-bl-2xl cursor-pointer whitespace-nowrap transition-colors"
          >
            {cancelText}
          </button>
          <div className="w-px bg-gray-100"></div>
          <button
            onClick={onConfirm}
            className={`flex-1 py-3.5 text-sm font-semibold rounded-br-2xl cursor-pointer whitespace-nowrap transition-colors ${danger ? 'text-red-500 hover:bg-red-50' : 'text-[#c9a96e] hover:bg-[#c9a96e]/5'}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}